var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.errorMsg,"width":"600"}},[_c('v-card',{staticClass:"text-sm-center pa-5"},[_c('h2',[_vm._v(_vm._s(_vm.errorMessageText))]),_c('v-btn',{staticClass:"mt-3",attrs:{"round":"","color":"primary"},on:{"click":function($event){return _vm.$store.dispatch('setErrorMessage',false)}}},[_vm._v("Close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }